var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-svgs-path": "theme_dark/project_zero.svg",
    viewBox: "0 0 220 200",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2800 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ProjectNew"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1800-100h300v300h-300z",
    transform: "matrix(.73333 0 0 .66667 1480 306.667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19249.7 1267h-50v60.8l50 9.74V1267z",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 3.2,
    transform: "matrix(.07647 0 -.2183 -.8732 1784.795 1497.148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19249.7 1267h-50v82.69",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.24,
    strokeLinejoin: "miter",
    transform: "matrix(1.13552 0 -.21699 .86796 -18612.74 -811.212)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19200.3 1283.96c-6.3.23-7.9.54-8.3 1.4v64.61c.6 1.17 14.7.95 15.5-.55v-64.61c-.5-.8-1.3-.93-7.2-.85zM19250.3 1265.88c-6.3.23-7.9.53-8.3 1.4v66.62c.6 1.16 14.7.95 15.5-.55v-66.62c-.5-.8-1.3-.93-7.2-.85z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(-.1332 0 -.22039 .88155 5812.674 -832.598)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M19199.7 1267h50v82.695h-50z",
    transform: "matrix(-1.33455 0 .01261 -.05045 28582.064 352.417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19199.8 1369.29c-.6-3.68-.8-9.2-.8-24.4v-82.7c0-12.86.1-14.08.5-15.01h50c.8 1.52 1 15.99 1 24.63v82.69c0 12.86-.1 14.09-.6 15.02h-50c0-.08-.1-.15-.1-.23zm49.2-39.42v-43.05h-48.5v43.05h48.5z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(-1.33455 0 .01261 -.05045 28582.064 352.417)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 6.66,
    d: "M19199.7 1267h50v82.695h-50z",
    transform: "matrix(-.07647 0 .10594 -.42378 4277.86 824.587)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 6.56,
    d: "M19199.7 1267h50v82.695h-50z",
    transform: "matrix(-.07647 0 .10754 -.43017 4269.21 935.737)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16552.5 1390h52.7",
    fill: "#fff",
    transform: "matrix(.42129 0 0 .42129 -4046.398 -194.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16605.4 1387.64c4.6.64 2 4.63-.2 4.73h-52.7c-4.5-.21-2.6-4.62 0-4.74 17.6 0 35.3-.81 52.9.01z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(.42129 0 0 .42129 -4046.398 -194.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16552.5 1390h95",
    fill: "#fff",
    transform: "matrix(.42129 0 0 .42129 -4010.738 -194.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16647.8 1387.64c4.4.84 1.9 4.6-.3 4.73h-95c-2.5-.15-3.6-4.52 0-4.74h95c.1 0 .2.01.3.01z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(.42129 0 0 .42129 -4010.738 -194.795)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16003 624.294c-7.6 8.064-9.1 23.123-3.8 32.949",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 1.94,
    transform: "matrix(1.14978 0 0 .89148 -15565.633 -208.494)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19262.4 1267h-62.7v82.69h66.8l-4.1-82.69z",
    fill: "#404040",
    transform: "matrix(-.85107 0 .01261 -.05045 19281.444 421.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19199.9 1369.32c-.8-2.41-1.3-9.25-1.4-24.43v-82.7c.1-12.86.2-14.08.9-15.01h62.7c.7.84.9 4.13 1.2 9.84l4.1 82.7c.6 13.19.3 28.66-.6 29.8h-66.8c0-.07-.1-.13-.1-.2zm64.3-39.45l-2.1-43.05h-61.2v43.05h63.3z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(-.85107 0 .01261 -.05045 19281.444 421.147)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19245.2 1314.42c1.8 1.05 14.9.67 15.4-.73l-6.3-52.75c-.7-1.13-14.8-1.14-15.5.59l6.3 52.74c0 .05.1.1.1.15z",
    fill: "#797979",
    fillRule: "nonzero",
    transform: "matrix(.03447 .12866 .90855 -.01528 1104.478 -2103.974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19246.3 1323.23c1.8 1 14.8.64 15.3-.75l-7.3-61.54c-.7-1.15-14.9-.84-15.5.59l7.3 61.54c.1.05.1.1.2.16z",
    fill: "#797979",
    fillRule: "nonzero",
    transform: "matrix(.03447 .12866 .90855 -.01528 1094.671 -2168.354)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19265.2 1097.4c1.4-2.57 2.2-5.57 3.5-8.18",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2,
    transform: "matrix(.95795 0 0 1.03606 -15481.433 -868.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19286.3 1102.52c1.1.08 1.3 1.47.1 1.96-2.2.95-3.9 3.03-6.3 3.56-.1.03-.3.04-.4.02-.1-.02-.3-.07-.4-.13-.7-.41-.5-1.42.4-1.82 2.3-.95 3.9-3.04 6.3-3.56.1-.02.1-.03.3-.03zM19277.7 1127.04c.5.05 1.1.36 1.6.57 2.7.95 6.1 1.67 6.5 2.64.4.91-.6 1.5-2.7.75-2.7-.95-6.2-1.7-6.5-2.71-.2-.61.2-1.28 1.1-1.25z",
    fill: "#797979",
    fillRule: "nonzero",
    transform: "matrix(.95795 0 0 1.03606 -15481.433 -868.863)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19167.2 1070.73c-.6 3.88-.9 7.8-1.3 11.7M19159.8 1076.51c4.4-.23 8.8-.55 13.2-.5",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 3.54,
    transform: "matrix(.56424 0 0 .56423 -7914.567 -339.462)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19167.3 1068.96c3.2.22 1 8.15.4 13.67-.4 2.21-3.8 2.26-3.3-2.58.5-4.78 0-11.14 2.9-11.09z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(.56424 0 0 .56423 -7824.656 -277.755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19172.6 1074.23c2.3.02 3.3 3.52-1.2 3.55-4.8.05-11.1 1.33-12.6.14-1.4-1.04-.6-3.09 2.6-3.27 3.7-.21 7.4-.43 11.2-.42z",
    fill: "#404040",
    fillRule: "nonzero",
    transform: "matrix(.56424 0 0 .56423 -7824.656 -277.755)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19167.2 1070.73c-.6 3.88-.9 7.8-1.3 11.7M19159.8 1076.51c4.4-.23 8.8-.55 13.2-.5",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 3.54,
    transform: "matrix(.56424 0 0 .56423 -7994.157 -297.504)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14492.231 -834.45) scale(.90071)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19276.9 1295l-2.9 11.86-7.4 3.34s-27.7 6.81-33.5 51.1h21.7l6.3-19.44 4.2 18.98 41.9 1.29-23-67.13h-7.3z",
    fill: "#797979"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19276.9 1295l-2.9 11.86-7.4 3.34s-27.7 6.81-33.5 51.1h21.7l6.3-19.44 4.2 18.98 41.9 1.29-23-67.13h-7.3z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M16017.8 601h47v19h-47z",
    transform: "matrix(.98975 0 0 1.08891 3394.58 632.633)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M19295.2 1306.61c-.2-.47-.1-.98.2-1.38.3-.41.7-.65 1.2-.64 3.7.02 10.8.07 10.8.07 10.9 17.48 28.7 27.88 28.3 44.64-.4 18.31-18 18-18 18s-18.5-49.92-22.5-60.69z",
    fill: "#797979",
    transform: "matrix(.85845 0 0 .85845 -13676.33 -776.881)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -.85845 .85845 0 1711.975 16981.555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19291.7 1372.3c-.1 10.6-8.8 12.98-7.7 24.55.9 8.77 9 17.03 20.7 17.45 19.5.7 27.6-13.14 27-26-.3-7.76-3-14.23-6.5-19.41v7.49c0 3.9-2.5 7.34-6.3 8.43 2.3-3.87 2-9.12 2-9.12-1.6 2.67-5.6 7.9-10.9 9.4-1.7.49-4.8-.31-5.8-2.46-1.1-2.29-.9-5.51 1.1-7.58 4.8-5 7.6-9.54 7.2-16.74-8-2.64-20.6-1.96-20.8 13.99z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19291.7 1372.3c-.1 10.6-8.8 12.98-7.7 24.55.9 8.77 9 17.03 20.7 17.45 19.5.7 27.6-13.14 27-26-.3-7.76-3-14.23-6.5-19.41v7.49c0 3.9-2.5 7.34-6.3 8.43 2.3-3.87 2-9.12 2-9.12-1.6 2.67-5.6 7.9-10.9 9.4-1.7.49-4.8-.31-5.8-2.46-1.1-2.29-.9-5.51 1.1-7.58 4.8-5 7.6-9.54 7.2-16.74-8-2.64-20.6-1.96-20.8 13.99z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16099.6 679.265c2.4 0 4.2 2.639 4.2 4.985 0 2.346-1.9 4.25-4.2 4.25-2.4 0-4.3-1.904-4.3-4.25s2-4.985 4.3-4.985z",
    fill: "#797979",
    transform: "matrix(-.28842 .97029 -.92651 -.2754 24572.3 -14047.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16099.6 679.265c2.4 0 4.2 2.639 4.2 4.985 0 2.346-1.9 4.25-4.2 4.25-2.4 0-4.3-1.904-4.3-4.25s2-4.985 4.3-4.985z",
    fill: "#fff",
    transform: "matrix(-.28842 .97029 -.92651 -.2754 24599.2 -14038.7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16099.6 679.265c2.4 0 4.2 2.639 4.2 4.985 0 2.346-1.9 4.25-4.2 4.25-2.4 0-4.3-1.904-4.3-4.25s2-4.985 4.3-4.985z",
    fill: "#fff",
    transform: "matrix(-.32435 1.09119 -1.04196 -.30972 25246.8 -15951)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19291.7 1372.3c-.1 10.6-8.8 12.98-7.7 24.55.9 8.77 9 17.03 20.7 17.45 19.5.7 27.6-13.14 27-26-.3-7.76-3-14.23-6.5-19.41v7.49c0 3.9-2.5 7.34-6.3 8.43 0 0 0 0 0 0 2.3-3.87 2-9.12 2-9.12-1.6 2.67-5.6 7.9-10.9 9.4-1.7.49-4.8-.31-5.8-2.46-1.1-2.29-.9-5.51 1.1-7.58 4.8-5 7.6-9.54 7.2-16.74-8-2.64-20.6-1.96-20.8 13.99z",
    fill: "none",
    stroke: "#404040",
    strokeWidth: 2.33
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16107.3 700.521c-1.2-.843-2.8-.789-3.9.132-.3.161-.6.347-.6.347-3.4 3.002-.9 9.41 3.1 8.522 3.2-.702 4.9-5.184 2.6-7.863-.3-.454-.7-.83-1.2-1.138z",
    fill: "#fff",
    transform: "matrix(.97753 -.51297 .51297 .97753 -13190.728 7988.74)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19470.3 1352.95h52.7s7.1.23 12.4.41c3.5.12 6.6 2.35 7.8 5.65.3.95.6 1.65.6 1.65",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.12,
    transform: "translate(-15499.133 -882.078) scale(.9415)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16068.8 683.026c6.5 1.439 12.1 7.636 13.9 11.287",
    fill: "none",
    stroke: "#bcbcbc",
    strokeWidth: 2.22,
    transform: "matrix(.89465 0 0 .9083 -11491.324 -220.686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16068.7 683.395c6.5 1.439 12.1 7.636 13.8 11.287",
    fill: "none",
    stroke: "#bcbcbc",
    strokeWidth: 1.88,
    transform: "matrix(.95306 0 0 1.1624 -12427.227 -397.535)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16068.9 683.279c6.5 1.439 12.1 7.636 13.8 11.287",
    fill: "none",
    stroke: "#bcbcbc",
    strokeWidth: 2.07,
    transform: "matrix(.85407 0 0 1.06841 -10833.823 -335.455)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19274.4 1304.12c-3.6.35-8.1 1.92-11.6 3.5-5.1 2.4-18.9 9.99-25.4 25.53-6.8 15.95-9.5 33.38-5.7 42.15 3.3 7.32 13 6.68 19 5.5 4.4-.86 25.8-7.04 34.9-6.79 4.1.11 9.2 1.35 16 8.5",
    fill: "none",
    stroke: "#bcbcbc",
    strokeWidth: 2.33,
    transform: "matrix(.86182 0 0 .8537 -13741.13 -770.678)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16058.9 653.508c-.4 5.37-2 10.503-5.9 14.712",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.92,
    transform: "matrix(1.1425 0 0 .9299 -15464.433 -236.626)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19538.1 1258.3c2 8.28-.1 14.71-4.9 19.81",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.66,
    transform: "matrix(.7015 0 0 .80046 -10814.023 -694.515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19529.2 1271.24c-3.3 3.35-3.7 6.53-.7 12.37 1.5 2.95 3.2 7.03 5.6 12.69",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.4,
    transform: "matrix(.83438 0 0 .83438 -13410.529 -737.193)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19160.4 1277.9c.2 6.19-4.2 11.55-10.3 12.49-.7.1-1.2.48-1.5 1.03-.3.56-.4 1.22-.1 1.81 1.6 3.71 6 7.85 12.6 5.02 7-2.99 4.9-15.42-.7-20.78v.43z",
    fill: "#797979",
    transform: "matrix(1.49043 .00256 -.00256 1.49043 -25673.656 -1657.511)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16022.3 611.33l36.8-31.33",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4.62,
    transform: "matrix(.52844 0 0 .31016 -5585.881 133.434)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16107.3 535s-8.5 11.9-8.5 17c0 3.863 3.9 7 8.5 7 4.7 0 8.5-3.137 8.5-7 0-5.1-8.5-17-8.5-17z",
    fill: "#fff",
    transform: "matrix(.1581 .47606 -.57807 .19198 679.295 -7463.167)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19504.3 1271.6c-5 16.25-26 20.96-37.3 31.4-12 11.16-16.1 29.79-4.5 42.37",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.4,
    transform: "matrix(.83438 0 0 .83438 -13416.929 -747.808)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19520.3 1259.31s-.4 1.41-.1 2.67",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.3,
    transform: "matrix(.83438 .06975 0 .83438 -13411.429 -2098.014)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19519.9 1259.48s0 1.24.3 2.5",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.4,
    transform: "matrix(.82411 .13052 -.13052 .8241 -13036.928 -3274.295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19145 1118.21c3.3 1.78 1.2 4.03 1.2 10.1 0 6.07 2.2 10-1.2 11.9-3.9 2.15-7.3-4.92-7.3-10.99s3.9-12.87 7.3-11.01z",
    fill: "#fff",
    transform: "matrix(1.2025 .78234 -.78234 1.2025 -19277.242 -16032.061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19139.2 1117.24c2.6 1.58 5.1 3.31 7.2 5.55",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.76,
    strokeLinejoin: "miter",
    transform: "matrix(.69429 -.15995 .16558 .71874 -10624.623 2555.238)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19538 1284c4 6.06 7.7 12.23 11.9 18.18",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.4,
    transform: "translate(-13410.829 -737.216) scale(.83438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19523.9 1259.19c.4 3.27 1.5 4.98 4.7 6.38l-4.5 2.39",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2.4,
    transform: "translate(-13409.429 -738.51) scale(.83438)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19504.3 1258.42c6.1-4.33 10.8-9.66 13.3-16.92",
    fill: "none",
    stroke: "#797979",
    strokeWidth: 2.4,
    transform: "translate(-13409.029 -736.584) scale(.83438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3322bd5d9f3d243be307d682e218ae82.svg";
export { ForwardRef as ReactComponent };